import { get, isEmpty } from "lodash";
export default {
  methods: {
    isValidPayload(payload, requiredFields) {
      return !requiredFields.some(path => isEmpty(get(payload, path)));
    }
  }
};